import { usePrincipal, useProposer } from '../../../application/authentication'
import { AccountValidationStatus, Proposer } from '../../../domain'
import { useApiErrorHandlingAsyncCallback } from '../../auth'
import { hasChanges } from './helpers'

export * from './data'

export const useProposerAdjustment = (onComplete?: () => Promise<void> | void) => {
  const { apiClient } = usePrincipal()
  const { proposer, setProposer } = useProposer()

  return useApiErrorHandlingAsyncCallback(async (data: Partial<Proposer>) => {
    if (hasChanges(proposer, data)) {
      setProposer(await apiClient.updateProposer(data))
    }

    await onComplete?.()
  })
}

export const useAccountValidation = (onSuccess?: () => void, onConflict?: () => void) => {
  const { apiClient } = usePrincipal()

  return useApiErrorHandlingAsyncCallback(async () => {
    const accountValidation = await apiClient.validateUserAccount('Final Mile')

    switch (accountValidation.validationStatus) {
      case AccountValidationStatus.OK:
        onSuccess?.()
        break
      case AccountValidationStatus.CONFLICT:
        onConflict?.()
        break
    }
  })
}
